import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
/**
 * Light wrapper for "label + control" pairs.
 * - Label: 12 / 600, ink-2 (Bloom 2.0 field label)
 * - Gap between label and control: 8px
 */
export function FormField({ label, htmlFor, required = false, className, labelClassName, children, }) {
    return (_jsxs("div", { className: cn("flex flex-col gap-2", className), children: [_jsxs(Label, { htmlFor: htmlFor, className: cn("text-caption font-semibold leading-4 text-ink-2", labelClassName), children: [label, " ", required ? (_jsx("span", { className: "text-text-error", "aria-hidden": "true", children: "*" })) : null] }), children] }));
}
